import { LevelId } from '../../../../domain/granulometry/levels/LevelGranulometry';

export const getCaseGranulometryEditLevelDetailsTriggerId = (levelId: LevelId) =>
  `caseEditLevelDetails${levelId}Trigger`;
